module.exports = __webpack_public_path__ + "img/9-sdg-border@2x.fdbbd288.png";